// src/pages/Patisserie/ProductPrice.jsx
import React from "react";
import { Box, Typography } from "@mui/material";

const money = (n) =>
  new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD" }).format(
    Number.isFinite(n) ? n : 0
  );

const ProductPrice = ({
  isDiscounted = false,
  currentUnit, // e.g., 4.24 (display/unit price after discounts)
  listUnit, // e.g., 4.99 (original unit price)
  suffix = "/each", // optional label
}) => {
  const showStrike = isDiscounted && Number(listUnit) > Number(currentUnit);

  return showStrike ? (
    <Box display="flex" alignItems="baseline" gap={1} sx={{ mb: 0.5 }}>
      <Typography variant="h6" fontWeight="bold" color="success.main">
        {money(currentUnit)}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ textDecoration: "line-through" }}>
        {money(listUnit)}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {suffix}
      </Typography>
    </Box>
  ) : (
    <Box sx={{ mb: 1 }}>
      <Typography component="span" variant="h6" fontWeight="bold">
        {money(listUnit)}
      </Typography>{" "}
      <Typography component="span" variant="body2" color="text.secondary">
        {suffix}
      </Typography>
    </Box>
  );
};

export default ProductPrice;
